export function convertShortDayToFull(shortDay) {
  const mapping = {
    Sun: "Sunday",
    Mon: "Monday",
    Tue: "Tuesday",
    Wed: "Wednesday",
    Thu: "Thursday",
    Fri: "Friday",
    Sat: "Saturday",
  };
  return mapping[shortDay];
}

export function convertFullDayToShort(fullDay) {
  const mapping = {
    Sunday: "SUN",
    Monday: "MON",
    Tuesday: "TUE",
    Wednesday: "WED",
    Thursday: "THU",
    Friday: "FRI",
    Saturday: "SAT",
  };
  return mapping[fullDay];
}

export function formatDaysOffKey(day1, day2) {
  return `${day1.slice(0, 3).toUpperCase()}_${day2.slice(0, 3).toUpperCase()}`;
}
